import React, {useEffect, useState} from "react"
import useGoBack from "@Routing/hooks/useGoBack"
import PriceChangeModal from "@CheckOrder/features/modals/components/PriceChangeModal";
import ExpiredSessionModal from "@CheckOrder/features/modals/components/ExpiredSessionModal";
import GenericCheckOrderErrorModal from "@CheckOrder/features/modals/components/GenericCheckOrderErrorModal";
import useDialog from "@Features/dialog/hooks/useDialog";
import GenericErrorModalType from "@CheckOrder/features/modals/types/GenericErrorModal.type";
import useOpenCheckOrderModals from "@CheckOrder/features/modals/hooks/useOpenCheckOrderModals";
import NoLongerPassengerClassAvailableModal
    from "@CheckOrder/features/modals/components/PassengerClassesNoLongerAvailableModal";

function CheckOrderModals() {
    const {goBack} = useGoBack()
    const [genericError, setGenericError] = useState<GenericErrorModalType>()

    const {
        dialogRef: expiredSessionModalRef,
        openModal: openExpiredSessionModal,
        closeModal: closeExpiredSessionModal,
    } = useDialog({onClose: goBack})

    const {
        dialogRef: priceChangeModalRef,
        openModal: openPriceChangeModal,
        closeModal: closePriceChangeModal,
    } = useDialog({onClose: goBack})

    const {
        dialogRef: passengerClassesNoLongerAvailableModalRef,
        openModal: openPassengerClassesNoLongerAvailableModal,
        closeModal: closePassengerClassesNoLongerAvailableModal,
    } = useDialog()

    const {
        dialogRef: genericErrorModalRef,
        openModal: openGenericErrorModal,
        closeModal: closeGenericErrorModal,
    } = useDialog()

    useOpenCheckOrderModals({
        openExpiredSessionModal,
        openPriceChangeModal,
        openPassengerClassesNoLongerAvailableModal,
        setGenericError,
    })

    useEffect(() => {
        if (genericError) {
            openGenericErrorModal()
        }
    }, [genericError]);

    return (
        <>
            <ExpiredSessionModal
                dialogRef={expiredSessionModalRef}
                closeModal={closeExpiredSessionModal}
            />
            <PriceChangeModal
                dialogRef={priceChangeModalRef}
                closeModal={closePriceChangeModal}
            />
            <NoLongerPassengerClassAvailableModal
                dialogRef={passengerClassesNoLongerAvailableModalRef}
                closeModal={closePassengerClassesNoLongerAvailableModal}
            />
            <GenericCheckOrderErrorModal
                dialogRef={genericErrorModalRef}
                closeModal={() => {
                    if (genericError?.action) {
                        genericError.action()
                    }
                    closeGenericErrorModal()
                }}
                title={genericError?.title}
                isInlineHtml={genericError?.isInlineHtml}
                message={genericError?.message}
                btnText={genericError?.btnText}
            />
        </>
    )
}

export default CheckOrderModals